import React from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Ticker from './components/Ticker';
import WhyPramaan from './components/WhyPramaan';
import FeaturesGrid from './components/FeaturesGrid';
import BuiltFor from './components/BuiltFor';
import Vision from './components/Vision';
import WaitlistCTA from './components/WaitlistCTA';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <WhyPramaan />
        <FeaturesGrid />
        <BuiltFor />
        <Vision />
        <WaitlistCTA />
      </main>
      <Footer />
    </>
  );
}
